import React, { Component } from "react";
import "./TextMessage.css";
const $ = window.$;
class TextMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
//   async componentDidMount(){
//       var skills = await localStorage.getItem('skill')
//       console.log(skills , "mounte")
//       await this.setState({skill : skills})
//   }

  render() {
      console.log(this.state.skill ,"drfrd")
    let marginTop = this.props.previousBySameSender == "true" ? 4 : 20;
    // ||this.props.previousBySameSender=="true"
    let obj = this.props.messageObj;
    // console.log("statement", obj)
    let spanForBot = (
      <span
        className="message"
        data-toggle={this.props.messageBySender == "true" ? "tooltip" : ""}
        data-placement={this.props.messageBySender == "true" ? "left" : "right"}
        title={new Date(obj.timestamp).toLocaleString()}
        dangerouslySetInnerHTML={{ __html: obj.label}}>
            {/* {localStorage.setItem("skill", this.props.excludedSkills)} */}
      </span>
    );
    let spanForUser = (
      <span
        className="message"
        data-toggle={this.props.messageBySender == "true" ? "tooltip" : ""}
        data-placement={this.props.messageBySender == "true" ? "left" : "right"}
        title={new Date(obj.timestamp).toLocaleString()}
      >
        {/* {this.state.skill ? this.state.skill : obj.label} */}
      </span>
    );
    return (
      <div
        className={
          "direct-chat-msg msg_left row " +
          (this.props.messageBySender == "true" ? "msg_right" : "")
        }
        style={{ marginTop: marginTop }}
      >
        <div
          className={
            "direct-chat-info clearfix row " +
            (this.props.messageBySender == "true" ||
            this.props.previousBySameSender == "true"
              ? "none"
              : "")
          }
        >
          <span className="direct-chat-name pull-left">Fellow Bot</span>{" "}
        </div>
        <div className="row">
          {this.props.messageBySender == "true" ? null : (
            <img src={this.props.botimage} alt="" className="direct-chat-img" />
          )}
          <div className="p">
            <span className="message_box">

              {/* {console.log(this.props.excludedSkills, "xxxxxxxxxxx")} */}
              {/* {this.props.excludedSkills? this.props.excludedSkills : null} */}
              {this.props.messageBySender == "true" ? spanForUser : spanForBot}
              
            </span>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    $(function() {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }
}

export default TextMessage;
